import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone, Mail } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: 'Home', href: '#home' },
    { label: 'Features', href: '#features' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Contact', href: '#contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-lg border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="text-2xl font-bold text-gray-900">
              <span className="text-[#6366F1]">Rent</span>Matez
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-gray-600 hover:text-[#6366F1] font-medium transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
            <a
              href="https://play.google.com/store/apps/details?id=com.webcare.paying_guest&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-[#6366F1] font-medium transition-colors duration-200"
            >
              Mobile App
            </a>
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center space-x-4 text-sm">
              <a href="tel:+91-8237712346" className="flex items-center space-x-1 text-gray-600 hover:text-[#6366F1] transition-colors">
                <Phone className="h-4 w-4" />
                <span>+91-8237712346</span>
              </a>
              <a href="mailto:info@smartrentmate.com" className="flex items-center space-x-1 text-gray-600 hover:text-[#6366F1] transition-colors">
                <Mail className="h-4 w-4" />
                <span>info@smartrentmate.com</span>
              </a>
            </div>
            {/* <Button className="bg-[#6366F1] hover:bg-[#5856eb] text-white px-6">
              Start Free Trial
            </Button> */}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-600 hover:text-[#6366F1] hover:bg-gray-100 transition-colors"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-gray-600 hover:text-[#6366F1] font-medium transition-colors duration-200"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="https://play.google.com/store/apps/details?id=com.webcare.paying_guest&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-600 hover:text-[#6366F1] font-medium transition-colors duration-200"
              >
                Mobile App
              </a>
              <div className="pt-4 space-y-3">
                <a href="tel:+91-8237712346" className="flex items-center space-x-2 text-gray-600">
                  <Phone className="h-4 w-4" />
                  <span>+91-8237712346</span>
                </a>
                <a href="mailto:info@smartrentmate.com" className="flex items-center space-x-2 text-gray-600">
                  <Mail className="h-4 w-4" />
                  <span>info@smartrentmate.com</span>
                </a>
                <Button className="w-full bg-[#6366F1] hover:bg-[#5856eb] text-white">
                  Start Free Trial
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};